import { render, staticRenderFns } from "./LawNormFormArticleItem.vue?vue&type=template&id=68b24ab0"
import script from "./LawNormFormArticleItem.vue?vue&type=script&lang=js"
export * from "./LawNormFormArticleItem.vue?vue&type=script&lang=js"
import style0 from "./LawNormFormArticleItem.vue?vue&type=style&index=0&id=68b24ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports